const configFormsDetails = {
    cca: [
        {
            fieldType: 'select',
            label: 'Payment Mode',
            name: 'paymentType',
            onlyAfterDefault: true,
            props: {
                data: [],
                label: 'Select',
                labelField: 'name',
                valueField: 'value',
            },
        },
        {
            fieldType: 'select',
            label: 'Sub Mode',
            name: 'subMode',
            onlyAfterDefault: true,
            props: {
                data: [],
                label: 'Select',
                labelField: 'name',
                valueField: 'value',
            },
        },
        {
            fieldType: 'input',
            label: 'Merchant PG Key',
            name: 'merchantPGKey',
            props: {
                placeholder: 'Enter PG Key',
                type: 'password',
            },
        },
        {
            fieldType: 'input',
            label: 'Security Key',
            name: 'merchantPGSecurityKey',
            props: {
                placeholder: 'Enter Security Key',
                type: 'password',
            },
        },
        {
            fieldType: 'input',
            label: 'Merchant PG Code',
            name: 'merchantPGCode',
            props: {
                placeholder: 'Enter PG Code',
                type: 'text',
            },
        },
        {
            fieldType: 'switch',
            name: 'status',
            props: {
                options: [
                    {
                        label: 'Credential Enabled',
                        value: 'ENABLED',
                    },
                ],
                labelField: 'label',
                valueField: 'value',
            },
        },
    ],
    cybs: [
        {
            fieldType: 'select',
            label: 'Payment Mode',
            name: 'paymentType',
            onlyAfterDefault: true,
            props: {
                data: [],
                label: 'Select',
                labelField: 'name',
                valueField: 'value',
            },
        },
        {
            fieldType: 'select',
            label: 'Sub Mode',
            name: 'subMode',
            onlyAfterDefault: true,
            props: {
                data: [],
                label: 'Select',
                labelField: 'name',
                valueField: 'value',
            },
        },
        {
            fieldType: 'input',
            label: 'Merchant PG Code',
            name: 'merchantPGCode',
            props: {
                placeholder: 'Enter PG Code',
                type: 'text',
            },
        },
        // {
        //     fieldType: 'input',
        //     label: 'Cybersource Account Password',
        //     name: 'accountPassword',
        //     props: {
        //         placeholder: 'Enter Cybersource Account Password',
        //         type: 'password',
        //     },
        // },
        {
            fieldType: 'input',
            label: 'Username',
            name: 'username',
            props: {
                placeholder: 'Enter Username',
                type: 'text',
            },
        },
        {
            fieldType: 'input',
            label: 'SOAP Key',
            name: 'soapKey',
            props: {
                placeholder: 'Enter SOAP',
                type: 'password',
            },
        },
        {
            fieldType: 'input',
            label: 'Security Key',
            name: 'merchantPGSecurityKey',
            props: {
                placeholder: 'Enter Security Key',
                type: 'password',
            },
        },
        {
            fieldType: 'input',
            label: 'Merchant PG Key',
            name: 'merchantPGKey',
            props: {
                placeholder: 'Enter PG Key',
                type: 'password',
            },
        },
        {
            fieldType: 'switch',
            name: 'status',
            props: {
                options: [
                    {
                        label: 'Credential Enabled',
                        value: 'ENABLED',
                    },
                ],
                labelField: 'label',
                valueField: 'value',
            },
        },
    ],
    migs: [
        {
            fieldType: 'select',
            label: 'Payment Mode',
            name: 'paymentType',
            onlyAfterDefault: true,
            props: {
                data: [],
                label: 'Select',
                labelField: 'name',
                valueField: 'value',
            },
        },
        {
            fieldType: 'select',
            label: 'Sub Mode',
            name: 'subMode',
            onlyAfterDefault: true,
            props: {
                data: [],
                label: 'Select',
                labelField: 'name',
                valueField: 'value',
            },
        },
        {
            fieldType: 'input',
            label: 'Merchant PG Code',
            name: 'merchantPGCode',
            props: {
                placeholder: 'Enter PG Code',
                type: 'text',
            },
        },
        {
            fieldType: 'input',
            label: 'Security Key',
            name: 'merchantPGSecurityKey',
            props: {
                placeholder: 'Enter Security Key',
                type: 'password',
            },
        },
        {
            fieldType: 'input',
            label: 'Merchant PG Key',
            name: 'merchantPGKey',
            props: {
                placeholder: 'Enter PG Key',
                type: 'password',
            },
        },
        {
            fieldType: 'input',
            label: 'Username',
            name: 'username',
            props: {
                placeholder: 'Enter Username',
                type: 'text',
            },
        },
        {
            fieldType: 'input',
            label: 'Password',
            name: 'password',
            props: {
                placeholder: 'Enter Password',
                type: 'password',
            },
        },
        {
            fieldType: 'switch',
            name: 'status',
            props: {
                options: [
                    {
                        label: 'Credential Enabled',
                        value: 'ENABLED',
                    },
                ],
                labelField: 'label',
                valueField: 'value',
            },
        },
    ],
    payU: [
        {
            fieldType: 'select',
            label: 'Payment Mode',
            name: 'paymentType',
            onlyAfterDefault: true,
            props: {
                data: [],
                label: 'Select',
                labelField: 'name',
                valueField: 'value',
            },
        },
        {
            fieldType: 'select',
            label: 'Sub Mode',
            name: 'subMode',
            onlyAfterDefault: true,
            props: {
                data: [],
                label: 'Select',
                labelField: 'name',
                valueField: 'value',
            },
        },
        {
            fieldType: 'input',
            label: 'Merchant PG Key',
            name: 'merchantPGKey',
            props: {
                placeholder: 'Enter PG Key',
                type: 'password',
            },
        },
        {
            fieldType: 'input',
            label: 'Merchant PG Code',
            name: 'merchantPGCode',
            props: {
                placeholder: 'Enter PG Code',
                type: 'text',
            },
        },
        {
            fieldType: 'switch',
            name: 'status',
            props: {
                options: [
                    {
                        label: 'Credential Enabled',
                        value: 'ENABLED',
                    },
                ],
                labelField: 'label',
                valueField: 'value',
            },
        },
    ],
    hdfc: [
        {
            fieldType: 'select',
            label: 'Payment Mode',
            name: 'paymentType',
            onlyAfterDefault: true,
            props: {
                data: [],
                label: 'Select',
                labelField: 'name',
                valueField: 'value',
            },
        },
        {
            fieldType: 'select',
            label: 'Sub Mode',
            name: 'subMode',
            onlyAfterDefault: true,
            props: {
                data: [],
                label: 'Select',
                labelField: 'name',
                valueField: 'value',
            },
        },
        {
            fieldType: 'input',
            label: 'Merchant PG Code',
            name: 'merchantPGCode',
            props: {
                placeholder: 'Enter PG Code',
                type: 'text',
            },
        },
        {
            fieldType: 'input',
            label: 'Merchant PG Key',
            name: 'merchantPGKey',
            props: {
                placeholder: 'Enter PG Key',
                type: 'password',
            },
        },
        {
            fieldType: 'input',
            label: 'Encryption Key',
            name: 'encryptionKey',
            props: {
                placeholder: 'Enter Encryption Key',
                type: 'password',
            },
        },
        {
            fieldType: 'switch',
            name: 'status',
            props: {
                options: [
                    {
                        label: 'Credential Enabled',
                        value: 'ENABLED',
                    },
                ],
                labelField: 'label',
                valueField: 'value',
            },
        },
    ],
    bdk: [
        {
            fieldType: 'select',
            label: 'Payment Mode',
            name: 'paymentType',
            onlyAfterDefault: true,
            props: {
                data: [],
                label: 'Select',
                labelField: 'name',
                valueField: 'value',
            },
        },
        {
            fieldType: 'select',
            label: 'Sub Mode',
            name: 'subMode',
            onlyAfterDefault: true,
            props: {
                data: [],
                label: 'Select',
                labelField: 'name',
                valueField: 'value',
            },
        },
        {
            fieldType: 'input',
            label: 'Merchant PG Code',
            name: 'merchantPGCode',
            props: {
                placeholder: 'Enter PG Code',
                type: 'text',
            },
        },
        {
            fieldType: 'input',
            label: 'Security Key',
            name: 'merchantPGSecurityKey',
            props: {
                placeholder: 'Enter Security Key',
                type: 'password',
            },
        },
        {
            fieldType: 'input',
            label: 'Merchant PG Key',
            name: 'merchantPGKey',
            props: {
                placeholder: 'Enter PG Key',
                type: 'text',
            },
        },
        {
            fieldType: 'switch',
            name: 'status',
            props: {
                options: [
                    {
                        label: 'Credential Enabled',
                        value: 'ENABLED',
                    },
                ],
                labelField: 'label',
                valueField: 'value',
            },
        },
    ],
    fiserv: [
        {
            fieldType: 'select',
            label: 'Payment Mode',
            name: 'paymentType',
            onlyAfterDefault: true,
            props: {
                data: [],
                label: 'Select',
                labelField: 'name',
                valueField: 'value',
            },
        },
        {
            fieldType: 'select',
            label: 'Sub Mode',
            name: 'subMode',
            onlyAfterDefault: true,
            props: {
                data: [],
                label: 'Select',
                labelField: 'name',
                valueField: 'value',
            },
        },
        {
            fieldType: 'input',
            label: 'Merchant PG Code',
            name: 'merchantPGCode',
            props: {
                placeholder: 'Enter PG Merchant Code',
                type: 'text',
            },
        },
        {
            fieldType: 'input',
            label: 'Security Key',
            name: 'merchantPGSecurityKey',
            props: {
                placeholder: 'Enter Merchant Security Key',
                type: 'password',
            },
        },
        {
            fieldType: 'input',
            label: 'Merchant PG Key',
            name: 'merchantPGKey',
            props: {
                placeholder: 'Enter Merchant PG Key',
                type: 'text',
            },
        },
        {
            fieldType: 'switch',
            name: 'status',
            props: {
                options: [
                    {
                        label: 'Credential Enabled',
                        value: 'ENABLED',
                    },
                ],
                labelField: 'label',
                valueField: 'value',
            },
        },
    ],
    mpgs: [
        {
            fieldType: 'select',
            label: 'Payment Mode',
            name: 'paymentType',
            onlyAfterDefault: true,
            props: {
                data: [],
                label: 'Select',
                labelField: 'name',
                valueField: 'value',
            },
        },
        {
            fieldType: 'select',
            label: 'Sub Mode',
            name: 'subMode',
            onlyAfterDefault: true,
            props: {
                data: [],
                label: 'Select',
                labelField: 'name',
                valueField: 'value',
            },
        },
        {
            fieldType: 'input',
            label: 'Security Key',
            name: 'merchantPGSecurityKey',
            props: {
                placeholder: 'Enter Merchant Security Key',
                type: 'password',
            },
        },
        {
            fieldType: 'input',
            label: 'Merchant PG Code',
            name: 'merchantPGCode',
            props: {
                placeholder: 'Enter PG Code',
                type: 'text',
            },
        },
        {
            fieldType: 'input',
            label: 'Merchant PG Key',
            name: 'merchantPGKey',
            props: {
                placeholder: 'Enter Merchant PG Key',
                type: 'text',
            },
        },
        {
            fieldType: 'switch',
            name: 'status',
            props: {
                options: [
                    {
                        label: 'Credential Enabled',
                        value: 'ENABLED',
                    },
                ],
                labelField: 'label',
                valueField: 'value',
            },
        },
    ],
    axisnb: [
        {
            fieldType: 'select',
            label: 'Payment Mode',
            name: 'paymentType',
            onlyAfterDefault: true,
            props: {
                data: [],
                label: 'Select',
                labelField: 'name',
                valueField: 'value',
            },
        },
        {
            fieldType: 'select',
            label: 'Sub Mode',
            name: 'subMode',
            onlyAfterDefault: true,
            props: {
                data: [],
                label: 'Select',
                labelField: 'name',
                valueField: 'value',
            },
        },
        {
            fieldType: 'input',
            label: 'Security Key',
            name: 'merchantPGSecurityKey',
            props: {
                placeholder: 'Enter Merchant Security Key',
                type: 'password',
            },
        },
        {
            fieldType: 'input',
            label: 'Merchant PG Code',
            name: 'merchantPGCode',
            props: {
                placeholder: 'Enter PG Code',
                type: 'text',
            },
        },
        {
            fieldType: 'input',
            label: 'Merchant PG Key',
            name: 'merchantPGKey',
            props: {
                placeholder: 'Enter Merchant PG Key',
                type: 'text',
            },
        },
        {
            fieldType: 'switch',
            name: 'status',
            props: {
                options: [
                    {
                        label: 'Credential Enabled',
                        value: 'ENABLED',
                    },
                ],
                labelField: 'label',
                valueField: 'value',
            },
        },
    ],
    wibmo: [
        {
            fieldType: 'select',
            label: 'Payment Mode',
            name: 'paymentType',
            onlyAfterDefault: true,
            props: {
                data: [],
                label: 'Select',
                labelField: 'name',
                valueField: 'value',
            },
        },
        {
            fieldType: 'select',
            label: 'Sub Mode',
            name: 'subMode',
            onlyAfterDefault: true,
            props: {
                data: [],
                label: 'Select',
                labelField: 'name',
                valueField: 'value',
            },
        },
        {
            fieldType: 'input',
            label: 'Security Key',
            name: 'merchantPGSecurityKey',
            props: {
                placeholder: 'Enter Merchant Security Key',
                type: 'password',
            },
        },
        {
            fieldType: 'input',
            label: 'Merchant PG Code',
            name: 'merchantPGCode',
            props: {
                placeholder: 'Enter PG Code',
                type: 'text',
            },
        },
        {
            fieldType: 'input',
            label: 'Merchant PG Key',
            name: 'merchantPGKey',
            props: {
                placeholder: 'Enter Merchant PG Key',
                type: 'text',
            },
        },
        {
            fieldType: 'switch',
            name: 'status',
            props: {
                options: [
                    {
                        label: 'Credential Enabled',
                        value: 'ENABLED',
                    },
                ],
                labelField: 'label',
                valueField: 'value',
            },
        },
    ],
};

export const pgDetails = [
    {
        configData: configFormsDetails.payU,
        date: '-',
        imagesName: 'payu',
        cardImages: 'payuPg',
        label: 'PG Name',
        modes: [
            {
                label: 'Live',
                value: 'live',
            },
            {
                label: 'Test',
                value: 'test',
            },
        ],
        name: 'Pay U',
        networks: ['NB', 'CC', 'DC'],
        uniqueId: 'payu',
        isConfigured: false,
    },
    {
        configData: configFormsDetails.cybs,
        date: '-',
        cardImages: 'CardTypes',
        imagesName: 'cyber',
        label: 'PG Name',
        modes: [
            {
                label: 'Live',
                value: 'live',
            },
            {
                label: 'Test',
                value: '',
            },
        ],
        name: 'CyberSource',
        networks: ['CC', 'DC'],
        uniqueId: 'cybs',
        isConfigured: false,
    },
    {
        configData: configFormsDetails.migs,
        date: '-',
        imagesName: 'migs',
        cardImages: 'CardTypesTwo',
        label: 'PG Name',
        modes: [
            {
                label: 'Live',
                value: 'live',
            },
            {
                label: 'Test',
                value: '',
            },
        ],
        name: 'MIGS',
        networks: ['CC', 'DC'],
        uniqueId: 'migs',
        isConfigured: false,
    },
    {
        configData: configFormsDetails.cca,
        date: '-',
        imagesName: 'ccavenue',
        cardImages: 'NetBanking',
        label: 'PG Name',
        modes: [
            {
                label: 'Live',
                value: 'live',
            },
            {
                label: 'Test',
                value: '',
            },
        ],
        name: 'CC Avenue',
        networks: ['NB'],
        uniqueId: 'cca',
        isConfigured: false,
    },
    {
        configData: configFormsDetails.hdfc,
        date: '-',
        imagesName: 'hdfc',
        cardImages: 'CardTypesTwo',
        label: 'PG Name',
        modes: [
            {
                label: 'Live',
                value: 'live',
            },
            {
                label: 'Test',
                value: '',
            },
        ],
        name: 'HDFC',
        networks: [['CC', 'DC']],
        uniqueId: 'hdfc',
        isConfigured: false,
    },
    {
        configData: configFormsDetails.bdk,
        date: '-',
        imagesName: 'billDesk',
        cardImages: 'payuPg',
        label: 'PG Name',
        modes: [
            {
                label: 'Live',
                value: 'live',
            },
            {
                label: 'Test',
                value: '',
            },
        ],
        name: 'Bill Desk',
        networks: ['CC', 'DC', 'NB', 'AMEX', 'DINER'],
        uniqueId: 'bdk',
        isConfigured: false,
    },
    {
        configData: configFormsDetails.fiserv,
        date: '-',
        imagesName: 'fiserv',
        cardImages: 'payuPg',
        label: 'PG Name',
        modes: [
            {
                label: 'Live',
                value: 'live',
            },
            {
                label: 'Test',
                value: '',
            },
        ],
        name: 'Fiserv',
        networks: ['CC', 'DC', 'NB', 'AMEX', 'DINER'],
        uniqueId: 'fiserv',
        isConfigured: false,
    },
    {
        configData: configFormsDetails.mpgs,
        date: '-',
        imagesName: 'migs',
        cardImages: 'CardTypesTwo',
        label: 'PG Name',
        modes: [
            {
                label: 'Live',
                value: 'live',
            },
            {
                label: 'Test',
                value: '',
            },
        ],
        name: 'MPGS',
        networks: ['CC', 'DC'],
        uniqueId: 'mpgs',
        isConfigured: false,
    },
    // addition of axisnb
    {
        configData: configFormsDetails.axisnb,
        date: '-',
        imagesName: 'migs',
        cardImages: 'NetBanking',
        label: 'PG Name',
        modes: [
            {
                label: 'Live',
                value: 'live',
            },
            {
                label: 'Test',
                value: '',
            },
        ],
        name: 'AXIS NB',
        networks: ['NB'],
        uniqueId: 'axisnb',
        isConfigured: false,
    },
    {
        configData: configFormsDetails.wibmo,
        date: '-',
        imagesName: 'wibmo',
        cardImages: 'CardTypesTwo',
        label: 'PG Name',
        modes: [
            {
                label: 'Live',
                value: 'live',
            },
            {
                label: 'Test',
                value: '',
            },
        ],
        name: 'WIBMO',
        networks: ['CC','DC'],
        uniqueId: 'wibmo',
        isConfigured: false,
    },
];

const DummyData = { pgDetails };
export default DummyData;
